var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Check",
    x: 2.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "#F9F9FB",
    stroke: "#A29DB0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnChecked);
export default __webpack_public_path__ + "static/media/unChecked.33b890f3e8ef8c96e84549ad025770a3.svg";
export { ForwardRef as ReactComponent };